import React from 'react'

export default () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 8C9.551 8 10 8.449 10 9C10 9.551 9.551 10 9 10C8.449 10 8 9.551 8 9C8 8.449 8.449 8 9 8ZM9 12C10.654 12 12 10.654 12 9C12 7.346 10.654 6 9 6C7.346 6 6 7.346 6 9C6 10.654 7.346 12 9 12ZM18 19H6C5.571 19 5.211 18.725 5.07 18.344L7.956 15.458C8.247 15.168 8.753 15.168 9.044 15.458L10.293 16.707C10.684 17.098 11.316 17.098 11.707 16.707L15.956 12.458C16.256 12.159 16.744 12.159 17.044 12.458L19 14.414V18C19 18.551 18.551 19 18 19ZM6 5H18C18.551 5 19 5.449 19 6V11.586L18.458 11.044C17.378 9.964 15.622 9.964 14.542 11.044L11 14.586L10.458 14.044C9.378 12.964 7.622 12.964 6.542 14.044L5 15.586V6C5 5.449 5.449 5 6 5ZM18 3H6C4.346 3 3 4.346 3 6V18C3 19.654 4.346 21 6 21H18C19.654 21 21 19.654 21 18V6C21 4.346 19.654 3 18 3Z"
      fill="#2E2D37"
    />
  </svg>
)
